import { useQueryParam } from "."

export const useShowProfileType = () => {
  const ncxPreview = useQueryParam("ncx_preview")
  return !!ncxPreview
}
